module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-SemiboldItalic.fce0a93d.otf";